<div #multiSelectDropdown class="dropdown {{dropdownContainerClass}}" [ngClass]="{show: isOpen}">
    <a class="{{ buttonClass }} dropdown-toggle user-select-none"
       ycnDisabled [disabled]="!!inputDisabled"
       (click)="toggle()"
       href="javascript:void(0)">
        <span>
            <span *ngIf="configCopy?.title?.label" class="{{dropdownItemClass}}">{{ configCopy.title.label }}{{ configCopy?.title?.value ? ': ' : '' }}</span>
            <span *ngIf="configCopy?.title?.value" class="text-default">
                <span class="text-gray-40">{{ configCopy?.title?.value }}</span>
            </span>
            <span *ngIf="configCopy?.showCount" class="mr-1">
                ({{ countSelected }})
            </span>
        </span>
    </a>
    <div class="dropdown-menu {{ dropdownClass }}" [ngClass]="{show: isOpen}">
        <div *ngFor="let listItem of configCopy.list">
            @if (listItem.dividerAbove) {
                <div class="dropdown-divider"></div>
            }
            <label class="custom-control custom-checkbox dropdown-item"
                   ycnDisabled [disabled]="listItem.disabled"
                   [ngClass]="{'custom-checkbox-tall': listItem.description, 'pr-2': listItem.icon }">
                <input class="custom-control-input"
                       type="checkbox"
                       (change)="handleChange(listItem)"
                       [(ngModel)]="listItem.selected">
                <span class="custom-control-indicator"></span>
                <span *ngIf="listItem.description" class="custom-control-description dropdown-item-text">
                    {{ listItem.label }}
                    <div class="dropdown-item-descr" [textContent]="listItem.description"></div>
                </span>
                <span *ngIf="!listItem.description" class="custom-control-description" [ngClass]="{ 'mr-12': listItem.icon }" [textContent]="listItem.label"></span>
                <svg *ngIf="listItem.icon" class="text-smallest ml-auto" ycnIcon [name]="listItem.icon"></svg>
                <ng-container *ngIf="listItem.helpName">
                    <span>&nbsp;</span>
                    <span class="help-toggler" (click)="helpModal.openModal(listItem.helpName); false">(?)</span>
                </ng-container>
            </label>
            <div *ngIf="listItem.dividerUnder" class="dropdown-divider"></div>
        </div>
    </div>
</div>
<ycn-help-modal #helpModal></ycn-help-modal>
